import React from 'react';
import { LongArrowRight, Typography } from '@dev/ee-components';
import { ContentBoxProps } from '@/components/CampaignCreator/SubjectAndContent/SubjectAndContentInterface';
import { ContentBoxWrapper, IconWrapper, StyledGrid, TitleWrapper } from './styled';

export const ContentBox = (props: ContentBoxProps): JSX.Element => {
    const { icon, title, description, onBoxClick, id } = props;

    return (
        <StyledGrid item>
            <ContentBoxWrapper id={id} onClick={onBoxClick}>
                <IconWrapper>{icon}</IconWrapper>
                <TitleWrapper>
                    <Typography variant="h2">{title}</Typography>
                    <LongArrowRight />
                </TitleWrapper>
                <Typography variant="body1" style={{ marginLeft: 16 }}>
                    {description}
                </Typography>
            </ContentBoxWrapper>
        </StyledGrid>
    );
};
